module.exports = __webpack_public_path__ + "0cc0318d5bf278fd1decdfd30b46bcba.jpg";